import { useAuth } from '@/auth/Auth';
import { AuthService } from '@/services/auth.service';
import { changeLanguage } from '@/translations';
import { useCallback } from 'react';

function normalizeLanguageCode(code?: string) {
  if (!code) return 'pt';
  return code.toLowerCase().split('-')[0];
}

export function useChangeLanguage() {
  const { isAuthenticated, token } = useAuth();

  return useCallback(
    async (lang: string) => {
      const normalizedLang = normalizeLanguageCode(lang);
      changeLanguage(normalizedLang);

      if (!isAuthenticated && !token) {
        return;
      }

      await AuthService.updateLanguagePreference(normalizedLang);
    },
    [isAuthenticated, token],
  );
}
